import { createFileRoute } from '@tanstack/react-router';
import { HandbookViewer } from '@/components/employee/handbook/handbook-viewer';

export const Route = createFileRoute('/(app)/employee/handbook/')({
  component: HandbookViewerPage,
});

function HandbookViewerPage() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <HandbookViewer />
    </div>
  );
}
